module.exports = __webpack_public_path__ + "static/media/files.e0ee6c97.svg";